import "./InputNote.css.ts.vanilla.css.mjs";
var _ = "p295__InputNote-3f5c_fc26660ac__11gjvaq0";
export {
  _ as note
};
//# sourceMappingURL=InputNote.css.mjs.map
